import { Typography, type TypographyProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Typography)<TypographyProps>(({ theme }) => ({
  paddingLeft: theme.spacing(1.5),
  borderLeft: `4px solid ${theme.palette.info.main}`,
  lineHeight: 1.3,
}));
